export default "__VITE_ASSET__B84czKvU__"